import React from 'react';

import 'src/app/components/ResetNewPasswordPresentation.scss';


const ResetNewPasswordPresentation = () => (
  <React.Fragment>
    <h1 styleName="welcome__headline">Dziękujemy!</h1>
    <h2 styleName="welcome__subline">Już za moment będziesz mógł się zalogować.</h2>
  </React.Fragment>
);

export default ResetNewPasswordPresentation;
